import React from "react";
import "./PartnerUsNew.css";
import PartnerForm from "./PartnerForm/PartnerForm";
import PartnerAuthorized from "./PartnerAuthorized/PartnerAuthorized";
import PartnerBenefit from "./PartnerBenefit/PartnerBenefit";
import PartnerDocument from "./PartnerDocument/PartnerDocument";
import PartnerWork from "./PartnerWork/PartnerWork";

function PartnerUsNew(){
    return(
        <>
            <PartnerForm />
            <PartnerAuthorized />
            <PartnerWork />
            <PartnerBenefit />
            <PartnerDocument />
        </>
    );
}
export default PartnerUsNew;